import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {EventEmitter, Injectable} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse/@fuse/services/splash-screen.service';
import {take} from 'rxjs/operators';
import {Subject} from 'rxjs';
import { Router } from '@angular/router';
import { FieldValues } from '../../eat/models/flow.model';
import { EventStatus } from '@shared/models/notification-message.model';

@Injectable({
  providedIn: 'root',
})

export class GtcPlanningCommandHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  unsubscribe$ = new Subject<void>();
  constructor(private commandService: CommandService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private router: Router) {
  }

  executeCommand(command: PlatformCommand) {
    if (command.fieldValues['DialogDefinition']) {
      delete command.fieldValues['DialogDefinition'];
    }
    this.executeCommandToApi(command);
  }
  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
         // this.commandService.handleResponse(commandResponse);
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
            this.invalidateSubject.invalidate("Refresh");
            return;
          }

          this.invalidateSubject.invalidate();
    },
    error => {
      console.error('Failed To Execute command', error);
      this.fuseSplashScreenService.hide();
    });
  }
}

  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged(event) {
    if (this.magicLinkModel.additionalCommands[`${event.fieldDefinition.key}LinkCommand`]) {
      const command = this.magicLinkModel.additionalCommands[`${event.fieldDefinition.key}LinkCommand`];
      command.fieldValues['ItemId'] = event.item.id;
      command.fieldValues['FieldKey'] = event.fieldDefinition.key;
      command.fieldValues['ScenarioId'] = event.item.cells['BaseScenario']?.value;
      command.fieldValues['PlatformLinkId'] = this.magicLinkModel.id;
      this.executeCommand(command);
    } else if (event.action) {
      if (this.magicLinkModel.additionalCommands[`${event.action.id}PlanningActionCommand`]) {
        const command = this.magicLinkModel.additionalCommands[`${event.action.id}PlanningActionCommand`];
        command.fieldValues['ItemId'] = event.item.id;
        command.fieldValues['PlatformLinkId'] = this.magicLinkModel.id;
        this.executeCommand(command);
      }
      if (this.magicLinkModel.additionalCommands[`${event.action.id}ActionCommand`]) {
        const command = this.magicLinkModel.additionalCommands[`${event.action.id}ActionCommand`];
        command.fieldValues['ItemId'] = event.item.id;
        command.fieldValues['ActionKey'] = event.fieldDefinition.key;
        command.fieldValues['PlatformLinkId'] = this.magicLinkModel.id;
        this.executeCommand(command);
      }
      
    }
  }

  destroy(): void {
  }
}
